<div *ngIf="state"
     class="next-success-notification">

  <div class="next-success-notification__notification main">
    <div class="next-success-notification__notification__text">
      <div class="next-success-notification__notification__title"
          [innerHTML]="state.title | translate | safeHtml">
      </div>
      <div *ngIf="state.subtitle"
           class="next-success-notification__notification__subtitle"
           [innerHTML]="state.subtitle | translate | safeHtml">
      </div>
      <div *ngIf="state.buttons"
           [ngClass]="{'next-success-notification__notification__buttons--multiple': state.buttons.length > 1}"
           class="next-success-notification__notification__buttons">
        <button *ngFor="let button of state.buttons"
                [class]="button.cssClass ? 'btn ' + button.cssClass : 'btn'"
                (click)="handleAction(button)">
          {{ button.label | translate }}
        </button>
      </div>
    </div>
    <div class="next-success-notification__notification__image">
      <img [src]="state.image" alt="">
    </div>
  </div>

  <div class="next-success-notification__products">
    <app-next-other-products [title]="otherProductsTitle"></app-next-other-products>
  </div>
</div>
